module.exports = __webpack_public_path__ + "static/media/img_ai_01.df732331.png";